interface UserIconProps {
  color?: string;
}
export default function UserIcon({ color = "none" }: UserIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="46.073"
      height="46.205"
      viewBox="0 0 46.073 46.205"
    >
      <path
        id="Path_354"
        d="M31.231,52.305H51.486a.773.773,0,0,0,.776-.706c.212-8.328-4.305-11.716-16.021-15.386a.636.636,0,0,1-.423-.423v-.071a.757.757,0,0,1,.071-.776C46.475,21.886,41.464,10.1,31.231,10.1S16.057,21.957,26.572,34.943a.642.642,0,0,1,.071.776v.071a.824.824,0,0,1-.423.423C14.5,39.883,10.057,43.271,10.2,51.6a.725.725,0,0,0,.776.706Z"
        transform="translate(-8.196 -8.1)"
        fill={color}
        strokeMiterlimit="10"
        strokeWidth="4"
      />
    </svg>
  );
}
